import React, { useEffect, useState } from "react";
import { getPageImages } from "../services/api";

let loadingMediaCache = null;
let loadingMediaRequest = null;

const loadLoadingMedia = () => {
    if (loadingMediaCache) return Promise.resolve(loadingMediaCache);
    if (!loadingMediaRequest) {
        loadingMediaRequest = getPageImages().then(response => {
            loadingMediaCache = Array.isArray(response?.data) ? response.data : [];
            return loadingMediaCache;
        }).catch(() => {
            loadingMediaCache = [];
            return loadingMediaCache;
        });
    }
    return loadingMediaRequest;
};

const LoadingMedia = ({ item }) => {
    if (!item?.image_url) return null;
    return item.media_type === "video"
        ? <video src={item.image_url} muted autoPlay loop playsInline preload="auto" />
        : <img src={item.image_url} alt="页面等待画面" />;
};

export const DefaultSketchLoading = () => (
    <svg className="room-loading-sketch" viewBox="0 0 600 260" role="img" aria-label="一个简笔画人物正在走向房子">
        <g className="sketch-house" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
            <path d="M390 103 L474 38 L558 103" strokeWidth="4" />
            <path d="M395 106 L474 45 L553 106" strokeWidth="1.5" opacity=".35" />
            <path d="M410 102 V212 H539 V102" strokeWidth="3.5" />
            <path d="M462 212 V156 H498 V212" strokeWidth="3" />
            <path d="M426 128 H451 V153 H426 Z" strokeWidth="2.5" />
            <path d="M512 76 V49 H530 V90" strokeWidth="3" />
            <path d="M418 218 C452 213 508 217 550 212" strokeWidth="1.5" opacity=".45" />
            <path d="M421 222 C470 219 519 224 557 217" strokeWidth="1" opacity=".25" />
        </g>

        <g className="sketch-walker" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="118" cy="82" r="14" strokeWidth="3" />
            <path d="M115 68 C121 64 128 68 132 73" strokeWidth="1.5" opacity=".5" />
            <path d="M118 97 L119 147" strokeWidth="4" />
            <path className="sketch-arm sketch-arm-front" d="M119 111 L146 134" strokeWidth="3.5" />
            <path className="sketch-arm sketch-arm-back" d="M119 112 L96 136" strokeWidth="3.5" />
            <path className="sketch-leg sketch-leg-front" d="M119 146 L143 188" strokeWidth="4" />
            <path className="sketch-leg sketch-leg-back" d="M119 146 L99 190" strokeWidth="4" />
            <path d="M139 189 L151 189 M87 191 L100 190" strokeWidth="3" />
        </g>

        <g className="sketch-motion" fill="none" stroke="currentColor" strokeLinecap="round" opacity=".28">
            <path d="M66 117 H93 M58 133 H88 M72 151 H96" />
            <path d="M72 210 C167 203 268 211 366 207" />
            <path d="M82 217 C180 211 279 220 375 213" />
        </g>
    </svg>
);

const RoomLoadingScene = ({ fullscreen = false, caption = "页面加载中，请稍候…" }) => {
    const [items, setItems] = useState(loadingMediaCache || []);
    const [overlayVisible, setOverlayVisible] = useState(!fullscreen);

    useEffect(() => {
        let active = true;
        loadLoadingMedia().then(nextItems => {
            if (active) setItems(nextItems);
        });
        return () => { active = false; };
    }, []);

    useEffect(() => {
        if (!fullscreen) return undefined;
        const timer = window.setTimeout(() => setOverlayVisible(true), 140);
        return () => window.clearTimeout(timer);
    }, [fullscreen]);

    const desktop = items.find(item => item.slot === "room_loading_desktop" && item.image_url);
    const mobile = items.find(item => item.slot === "room_loading_mobile" && item.image_url);
    const desktopMedia = desktop || mobile;
    const mobileMedia = mobile || desktop;

    if (!overlayVisible) return null;

    return (
        <div className={`room-loading-scene${fullscreen ? " page-loading-overlay" : ""}`} role="status" aria-live="polite">
            {desktopMedia || mobileMedia ? <>
                <div className="room-loading-custom room-loading-custom-desktop"><LoadingMedia item={desktopMedia} /></div>
                <div className="room-loading-custom room-loading-custom-mobile"><LoadingMedia item={mobileMedia} /></div>
            </> : <DefaultSketchLoading />}
            <div className="room-loading-caption">{caption}</div>
        </div>
    );
};

export const PageLoadingOverlay = ({ caption }) => <RoomLoadingScene fullscreen caption={caption} />;

export default RoomLoadingScene;
